export const HOUSE_NAME_KEY = '__name'

export const DEFAULT_FIELD_TYPE = 'input'
